import { TFunction } from '@lyearn/i18n';
import {
  BookOpenOutline,
  BookOutline,
  CheckmarkCircleOutlineLegacy,
  File,
  Film,
  Music,
  Search,
} from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Image } from '@/components/Image';
import { EntityMediaType, ExternalContentTypeEnum, ProviderType } from '@/types/schema';

export const CONTENT_TYPE_OPTIONS = [
  { label: 'Course', Icon: BookOutline, value: ExternalContentTypeEnum.Course },
  { label: 'Article', Icon: File, value: ExternalContentTypeEnum.Article },
  { label: 'Research Paper', Icon: Search, value: ExternalContentTypeEnum.ResearchPaper },
  { label: 'Book', Icon: BookOpenOutline, value: ExternalContentTypeEnum.Book },
  { label: 'Podcast', Icon: Music, value: ExternalContentTypeEnum.Podcast },
  { label: 'Video', Icon: Film, value: ExternalContentTypeEnum.Video },
  {
    label: 'Assessment',
    Icon: CheckmarkCircleOutlineLegacy,
    value: ExternalContentTypeEnum.Assessment,
  },
];
export const getContentTypeOptions = (t: TFunction) => {
  return [
    {
      label: t('Common:ExternalContentType.Course'),
      Icon: BookOutline,
      value: ExternalContentTypeEnum.Course,
    },
    {
      label: t('Common:ExternalContentType.Article'),
      Icon: File,
      value: ExternalContentTypeEnum.Article,
    },
    {
      label: t('Common:ExternalContentType.ResearchPaper'),
      Icon: Search,
      value: ExternalContentTypeEnum.ResearchPaper,
    },
    {
      label: t('Common:ExternalContentType.Book'),
      Icon: BookOpenOutline,
      value: ExternalContentTypeEnum.Book,
    },
    {
      label: t('Common:ExternalContentType.Podcast'),
      Icon: Music,
      value: ExternalContentTypeEnum.Podcast,
    },
    {
      label: t('Common:ExternalContentType.Video'),
      Icon: Film,
      value: ExternalContentTypeEnum.Video,
    },
    {
      label: t('Common:ExternalContentType.Assessment'),
      Icon: CheckmarkCircleOutlineLegacy,
      value: ExternalContentTypeEnum.Assessment,
    },
  ];
};
const RenderProviderImage = ({
  logo,
  className,
}: {
  logo: EntityMediaType;
  className?: string;
}) => {
  if (!logo?.url) {
    return null;
  }

  return (
    <Image
      alt={logo.name}
      className={cn('flex-shrink-0 rounded-4', className)}
      layout="fill"
      src={logo.url!}
    />
  );
};

export const getProviderOptions = (providers: ProviderType[]) =>
  providers.map((provider) => ({
    ...provider,
    value: provider.id,
    label: provider.name,
    Icon: ({ className }: { className?: string }) => (
      <RenderProviderImage className={className} logo={provider.logo} />
    ),
  }));

export const EXTERNAL_CONTENT_TYPE_ACTION_LABEL = {
  [ExternalContentTypeEnum.Course]: 'ExternalContent:Details.Actions.StartCourse',
  [ExternalContentTypeEnum.Article]: 'ExternalContent:Details.Actions.ReadArticle',
  [ExternalContentTypeEnum.Book]: 'ExternalContent:Details.Actions.ReadBook',
  [ExternalContentTypeEnum.Video]: 'ExternalContent:Details.Actions.WatchVideo',
  [ExternalContentTypeEnum.Podcast]: 'ExternalContent:Details.Actions.ListenToPodcast',
  [ExternalContentTypeEnum.Assessment]: 'Common:SkillDetails.TakeAssessment',
  [ExternalContentTypeEnum.ResearchPaper]: 'ExternalContent:Details.Actions.ViewResearchPaper',
};

export const EXTERNAL_CONTENT_TYPE_LABEL = {
  [ExternalContentTypeEnum.Course]: 'ExternalContentType.Course',
  [ExternalContentTypeEnum.Article]: 'ExternalContentType.Article',
  [ExternalContentTypeEnum.Book]: 'ExternalContentType.Book',
  [ExternalContentTypeEnum.Video]: 'ExternalContentType.Video',
  [ExternalContentTypeEnum.Podcast]: 'ExternalContentType.Podcast',
  [ExternalContentTypeEnum.Assessment]: 'ExternalContentType.Assessment',
  [ExternalContentTypeEnum.ResearchPaper]: 'ExternalContentType.ResearchPaper',
};
